import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

type PageShortcutLinkProps = {
  to: string;
  children: ReactNode;
  prefix?: string;
};

export function PageShortcutLink({ to, children, prefix }: PageShortcutLinkProps) {
  return (
    <Link to={to} className="erp-shortcut">
      {prefix ? <span className="erp-shortcut-prefix">{prefix}</span> : null}
      <span className="erp-shortcut-label">{children}</span>
      <ArrowRightIcon className="erp-shortcut-icon" aria-hidden="true" />
    </Link>
  );
}
